module.exports = __webpack_public_path__ + "356514414150f44930dab863a2bd0319.fbx";